import { COLOR_PALETTE } from 'app/constants/ColorPalette';
import { NAVIGATION_BACKGROUND_COLOR, NAVIGATION_BACKGROUND_HIGHLIGHT_COLOR, NAVIGATION_TEXT_COLOR, NAVIGATION_TEXT_HIGHLIGHT_COLOR } from 'app/constants/Colors';
import { buttonReset } from 'app/constants/Styles';
import { IStyles } from 'app/utils/css';

interface IGetNavLinkStylesParams {
  /**
   * For allowing dropdowns to keep hover style while they are open.
   */
  active: boolean;
  /**
   * Applies special styles for some cases that a logo is present.
   */
  logo: boolean;
  /**
   * Is the content being hovered or not?
   */
  hovered: boolean;
  /**
   * For allowing dropdown items work as a dropdown with selected item.
   */
  selected: boolean;
}

/**
 * Helper for generating styles that are representative of a navigation link.
 */
export const getNavLinkStyles = ({ active, hovered, logo, selected }: IGetNavLinkStylesParams): IStyles => ({
  ...buttonReset,
  cursor: 'pointer',
  textDecoration: 'none',
  padding: '1.5em 1em',
  color: NAVIGATION_TEXT_COLOR,
  borderRadius: '0',
  display: 'flex',
  flex: 0,
  alignItems: 'center',
  whiteSpace: 'nowrap',
  backgroundColor: NAVIGATION_BACKGROUND_COLOR,

  ...(hovered || active) && {
    color: NAVIGATION_TEXT_HIGHLIGHT_COLOR,
    backgroundColor: NAVIGATION_BACKGROUND_HIGHLIGHT_COLOR,
  },

  ...selected && {
    color: NAVIGATION_TEXT_HIGHLIGHT_COLOR,
    backgroundColor: COLOR_PALETTE.grey.light,
  },

  ...logo && {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    paddingLeft: 0,
    color: NAVIGATION_TEXT_HIGHLIGHT_COLOR,
    backgroundColor: undefined, // Disable hover effect
  },
});
